import { Form, Stack } from "react-bootstrap";
import { orderAtom } from "../atoms/atoms";
import { useAtom, useSetAtom } from "jotai";
import { useState } from "react";

const CustomerName = () => {

    const [customerFirstName, setCustomerFirstName] = useState("");
    const [customerLastName, setCustomerLastName] = useState("");

    const setOrder = useSetAtom(orderAtom);

    const onFirstNameChange = (e) => {
        setCustomerFirstName(e.target.value);
        setOrder((prev) => ({
            ...prev,
            customerFirstName: e.target.value,
        }));
    }

    const onLastNameChange = (e) => {
        setCustomerLastName(e.target.value);
        setOrder((prev) => ({
            ...prev,
            customerLastName: e.target.value,
        }));
    }

    return (

        <div className="row">
            <div className="col-12 col-md-6">


                <Form.Group className="mb-3" controlId="formCustomerFirstName">
                    <Form.Label>Imię:</Form.Label>
                    <Form.Control
                        onChange={(e) => onFirstNameChange(e)}
                        value={customerFirstName}
                        maxLength="200"
                        type="text"
                        placeholder="Imię"
                        autoComplete="given-name" />
                </Form.Group>
            </div>
            <div className="col-12 col-md-6">

                <Form.Group className="mb-3" controlId="formCustomerLastName">
                    <Form.Label>Nazwisko:</Form.Label>
                    <Form.Control
                        onChange={(e) => onLastNameChange(e)}
                        value={customerLastName}
                        maxLength="200"
                        type="text"
                        placeholder="Nazwisko"
                        autoComplete="family-name" />
                </Form.Group>
            </div>
        </div>


    )
}

export default CustomerName;